import React from 'react'

class CustomSelect extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      isOpen: false,
      value: props.value,
    }

    this.handleBlur = this.handleBlur.bind(this)
    this.handleChange = this.handleChange.bind(this)
    this.handleItemClick = this.handleItemClick.bind(this)
    this.handleOpen = this.handleOpen.bind(this)
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.setState({ value: this.props.value })
    }
  }

  handleBlur() {
    this.setState(
      {
        isOpen: false,
      },
      () => {
        /**
         * value reset quando
         * non viene scelto alcun valore
         * viene scelto un valore invalido
         */
        if (this.state.value === '' || this.state.value !== this.props.value) {
          this.setState({
            value: this.props.value,
          })
        }
      }
    )
  }

  handleChange(event) {
    this.setState({
      value: event.target.value,
    })
  }

  handleItemClick(item) {
    this.setState({
      isOpen: false,
    })
    this.props.onSelect(item)
  }

  handleOpen() {
    this.setState({
      isOpen: true,
      value: '',
    })
  }

  render() {
    const filter = new RegExp(this.state.value.replace('+', '\\+'), 'i')

    return (
      <div
        className={`custom-select ${
          this.state.isOpen ? 'custom-select--active' : ''
        }`}
        style={this.props.style}
      >
        <input
          className="custom-select__label form-input big input-data"
          onBlur={this.handleBlur}
          onChange={this.handleChange}
          onClick={this.handleOpen}
          type="text"
          value={this.state.value}
        />

        <div className="custom-select__list">
          {this.props.items
            .filter(item => filter.test(item.value) || filter.test(item.name))
            .map(item => (
              <div
                className="custom-select__item"
                key={item.name}
                onMouseDown={() => this.handleItemClick(item)}
              >
                {this.props.renderItem(item)}
              </div>
            ))}
        </div>
      </div>
    )
  }
}

export default CustomSelect
